import React from 'react'

import { Heading4, Text, Space } from '@gousto-internal/citrus-react'

type SectionHeaderProps = {
  title: string
  subtitle?: string
}

export const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => (
  <>
    <Heading4>{title}</Heading4>
    {subtitle && <Text size={1}>{subtitle}</Text>}
    <Space size={[3, 6]} />
  </>
)
